import { defineMessages } from "react-intl";

export const scope = "components.MarketPositionSymbol";

export const messages = defineMessages({
  totalVolume: {
    id: `${scope}.totalVolume`,
    defaultMessage: "Total en cartera",
  },
  availableVolume: {
    id: `${scope}.availableVolume`,
    defaultMessage: "Disponible (C.I.)",
  },
  collateralVolume: {
    id: `${scope}.collateralVolume`,
    defaultMessage: "Cantidad en caución",
  },
  guaranteedVolume: {
    id: `${scope}.guaranteedVolume`,
    defaultMessage: "Cantidad en garantía",
  },
  thisDayLabel: {
    id: `${scope}.thisDayLabel`,
    defaultMessage: "24 hs",
  },
  MoreThatADayLabel: {
    id: `${scope}.MoreThatADayLabel`,
    defaultMessage: "+24 hs",
  },
  amountLabel: {
    id: `${scope}.amountLabel`,
    defaultMessage: "Cantidad",
  },
  priceLabel: {
    id: `${scope}.priceLabel`,
    defaultMessage: "Precio",
  },
  valuationLabel: {
    id: `${scope}.valuationLabel`,
    defaultMessage: "Valuación",
  },
  percentageLabel: {
    id: `${scope}.percentageLabel`,
    defaultMessage: "Porcentaje de la cartera",
  },
  lastMovements: {
    id: `${scope}.lastMovements`,
    defaultMessage: "Últimos movimientos",
  },
});
